import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import moment from 'moment';

const firebaseConfig = {
  apiKey: 'AIzaSyB5_wVxmSwgQaudfgfZASbIN3NsV_DC2DY',
  authDomain: 'chat-eb7db.firebaseapp.com',
  projectId: 'chat-eb7db',
  storageBucket: 'chat-eb7db.appspot.com',
  messagingSenderId: '95565963179',
  appId: '1:95565963179:web:26e6c3a92806e853bb7cee',
  measurementId: 'G-TQY2CMMRZY',
};

const useFirebase = () => {
  const [db, setDb]: any = useState(null);

  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);
    setDb(db);
  }, []);

  return db;
};

const StatsPage = ({ user }: any) => {
  const db = useFirebase();
  const [messages, setMessages]: any = useState([]);

  const getHistory = async () => {
    const history = collection(db, 'history');

    const q = query(history, orderBy('createdAt', 'desc'), limit(1000));

    const querySnapshot = await getDocs(q);

    const newMesssages: any = [];
    querySnapshot.forEach(doc => {
      newMesssages.push(doc);
    });

    setMessages([...newMesssages]);
  };

  useEffect(() => {
    if (!db) return;
    getHistory();
  }, [db]);

  return (
    <div style={{ margin: 20 }}>
      {messages.map((message: any) => {
        return (
          <div key={message.id} style={{ display: 'flex', gap: '1rem' }}>
            <div>{message.data().user}</div>
            <div>{message.data().createdAt}</div>
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  invoices: selectors.getAllInvoices(state),
  user: selectors.getUser(state),
  sites: selectors.admin.siteOptionsDetail(state),
  users: selectors.getUserOptions(state),
  editors: selectors.getEditors(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  addInvoice: bindActionCreators(actions.invoices.addInvoice, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  getUsers: bindActionCreators(actions.admin.getUsers, dispatch),
  getInvoices: bindActionCreators(actions.invoices.getInvoices, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatsPage);
